// extracted by mini-css-extract-plugin
export default {"title":"Item_title__EYL20","wrapper":"Item_wrapper__vsK1m","dateRelease":"Item_dateRelease__npzGW"};